import { Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { BorderedFormGrid } from "../../../Forms/BorderedFormGrid";
import Supplier from "../../Supplier";
import { SupplierFormProps } from "../SupplierFormProps";
import { OpenGoogleMapsIconButton } from "../../../GoogleMaps/OpenGoogleMapsIconButton";
import { useGoogleMapsModal } from "../../../GoogleMaps/useGoogleMapsModal";
import { TextFieldInput } from "../../../Forms/TextFieldInput";

export const SupplierCoordinatesForm = ({ disabledFields }: SupplierFormProps) => {
  const { control } = useFormContext<Supplier>();

  const { googleMapsModal, openGoogleMapsModal } = useGoogleMapsModal<Supplier>(
    "Latitude",
    "Longitude"
  );

  return (
    <BorderedFormGrid>
      {googleMapsModal}
      <Grid item xs={12}>
        <TextFieldInput
          name="Latitude"
          control={control}
          disabledFields={disabledFields}
          InputProps={{
            endAdornment: <OpenGoogleMapsIconButton onClick={openGoogleMapsModal} />,
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <TextFieldInput
          name="Longitude"
          control={control}
          disabledFields={disabledFields}
          InputProps={{
            endAdornment: <OpenGoogleMapsIconButton onClick={openGoogleMapsModal} />,
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <TextFieldInput
          name="MGLatitude"
          control={control}
          label="M&G Latitude"
          disabledFields={disabledFields}
        />
      </Grid>
      <Grid item xs={12}>
        <TextFieldInput
          name="MGLongitude"
          control={control}
          label="M&G Longitude"
          disabledFields={disabledFields}
        />
      </Grid>
    </BorderedFormGrid>
  );
};
